export default {
	SYSTEM: 'system',
	ADMIN: 'admin',
};
